/**
 * inputFilters — filtros de entrada compartidos por los formularios de
 * médico (pre-registro, edición admin y perfil propio) para los campos de
 * identidad y códigos SEIS.
 */

export const MAX_30 = 30;

/** Letras (incl. acentuadas), números y guiones — cédula y N° de registro de idoneidad. */
export function soloAlfanumericoGuiones(v: string): string {
  return v.replace(/[^a-zA-Z0-9À-ſ-]/g, '').slice(0, MAX_30);
}

/** Solo dígitos — códigos numéricos SEIS. */
export function soloDigitos(v: string): string {
  return v.replace(/\D/g, '').slice(0, MAX_30);
}
